import React from 'react'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet-async';

function Contact() {
    return (
        <>
            <Helmet>
                <title>Inspectiver | Contact Us</title>
                <meta name="description" content="Contact Inspectiver for help with inspection orders, inspector opportunities, or general inquiries. We're here to assist you." />
                <meta name="keywords" content="pre purchase car inspection, pre purchase car inspection near me, contact Inspectiver, car inspection support, customer service, Inspectiver support, Inspectiver phone, Inspectiver" />
                <link rel="canonical" href="/contact" />
            </Helmet>
            <HerosectionHeader folder1={"Pages"} folder2={"Contacts"} name={"Contact Us"} />
            <div className="page-content">
                <section>
                    <Container>
                        <Row className="justify-content-left">
                            <Col lg="8">
                                <div className="mb-5">
                                    <h2 className="mb-0">
                                        <span className="font-w-4 d-block"></span>How to Reach Us
                                    </h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <div className="card border-light  mb-3" >
                                    <div className="card-header">Email</div>
                                    <div className="card-body">
                                        <h5 className="card-title">Email us</h5>
                                        <p className="card-text"><i className="las la-envelope"></i> <a className="btn-link" href="mailto:support@inspectiver.com"> support@inspectiver.com</a></p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="card border-light  mb-3">
                                    <div className="card-header">Phone</div>
                                    <div className="card-body">
                                        <h5 className="card-title">Call us</h5>
                                        <p className="card-text"><i className="las la-phone-volume"></i><a className="btn-link" href="tel:+15624855485"> (562) 485-5485</a></p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="card border-light  mb-3" >
                                    <div className="card-header">Business Hours</div>
                                    <div className="card-body">
                                        <h5 className="card-title">Monday - Sunday (Pacific Time)</h5>
                                        <p className="card-text"> <i className="las la-clock"></i> 8:00 AM - 6:00 PM</p>
                                    </div>
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col lg="12" md="12">
                                <p className="mb-3">For any questions, feedback, or support, please don’t hesitate to reach out.</p>
                                <p className="mb-3">Our support team is available and ready to assist you.</p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </>
    )
}

export default Contact
